import {goKakaotalkAppStore} from '@zzng/common/utils/scheme';

import PageLayout from '@/shared/components/PageLayout';
import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';

const InvalidVersionPage = () => {
  return (
    <PageLayout
      tiara={{pageName: TIARA_PAGE_NAME.ERROR, pageAction: TIARA_ACTION.INVALID_VERSION_ERROR}}
      className="container-bridge"
      articleClassName="content-full"
    >
      <div className="inner_g">
        <div className="group_empty type2">
          <strong className="tit_g">
            <span className="item_txt" role="text">
              <span className="txt_tit">최신버전으로 업데이트해 주세요</span>
            </span>
          </strong>
          <p className="txt_g">카카오톡 최신버전 업데이트가 필요한 기능입니다.</p>
          <button
            type="button"
            className="btn btn_yellow type2"
            onClick={goKakaotalkAppStore}
            data-tiara-action-name={TIARA_ACTION.INVALID_VERSION_CLICK}
          >
            최신버전 업데이트
          </button>
        </div>
      </div>
    </PageLayout>
  );
};

export default InvalidVersionPage;
